import { useLingui } from "@lingui/react/macro";
import { cn } from "@/lib/utils";
import type { HelpCategoryId } from "@/types/help";
import { CATEGORY_META, CATEGORY_ORDER } from "./category-meta";

export type CategoryFilter = "all" | HelpCategoryId;

export function HelpCategoryTabs({
  value,
  onChange,
}: {
  value: CategoryFilter;
  onChange: (next: CategoryFilter) => void;
}) {
  const { t } = useLingui();

  const tabs: { id: CategoryFilter; label: string }[] = [
    { id: "all", label: t`All` },
    ...CATEGORY_ORDER.map((id) => ({ id, label: t(CATEGORY_META[id].label) })),
  ];

  return (
    <div className="flex items-center gap-1 px-1">
      {tabs.map((tab) => {
        const isActive = tab.id === value;
        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => onChange(tab.id)}
            className={cn(
              "rounded-md px-4 py-2 text-sm font-medium transition-colors",
              isActive
                ? "bg-(--color-action) text-(--color-action-fg)"
                : "bg-(--gray-100) text-(--gray-500) hover:bg-(--gray-200)",
            )}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
